'use client';

import { EventCard } from '@/sanity/fetchEvents';
import { URL_PATH_EVENT } from '@/shared/constants';
import HIHImage from './HIHImage';
import HIHLink from './Link';
import EventDateAndLocation from '../sections/EventDateAndLocation';
import ActionFavorite from '../action/favorite/ActionFavorite';
import {
  MATOMO_CONTENT_INTERACTIONS,
  MATOMO_CONTENT_KINDS,
  buildContentPiece,
} from '@/utils/matomo';
import { useContentImpression } from '@/hooks/useContentImpression';
import { ContentBlockProvider } from './ContentTracking';
import styles from './SingleEventCardMobileHorizontal.module.scss';

interface SingleEventCardMobileHorizontalProps {
  event: EventCard;
}

export default function SingleEventCardMobileHorizontal({
  event,
}: SingleEventCardMobileHorizontalProps) {
  const eventPath = `/${URL_PATH_EVENT}/${event.slug.current}`;

  // Trackt nur innerhalb eines ContentTrackingModule, sonst No-Op – siehe ContentTracking.
  const { ref, block, trackInteraction } = useContentImpression({
    contentPiece: buildContentPiece(MATOMO_CONTENT_KINDS.EVENT, event.slug.current),
    contentTarget: eventPath,
  });

  return (
    <ContentBlockProvider block={block}>
      <div ref={ref} className={styles.singleEventCardMobileHorizontal}>
        <HIHLink
          key={event._id}
          href={eventPath}
          onClick={() =>
            trackInteraction(MATOMO_CONTENT_INTERACTIONS.DETAILSEITE_GEOEFFNET)
          }
        >
          <div className={styles.header}>
            <div className={styles.imageWrapper}>
              <HIHImage
                image={event.coverImage}
                width={90}
                height={90}
                fill
                className={styles.image}
              />
            </div>
            <div className={styles.info}>
              <div className={styles.titleWrapper}>
                <div className={styles.title}>{event.title}</div>
              </div>
            </div>
          </div>
        </HIHLink>
        <EventDateAndLocation event={event} className={styles.eventDateLocation} />
        <ActionFavorite
          id={event._id}
          className={styles.favoriteButton}
          bookmarkType="Event"
          disableBackgroundColor={true}
        />
      </div>
    </ContentBlockProvider>
  );
}
